import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function HeroSection() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useScrollReveal(0.1);
  const {
    ref: imgRef,
    isVisible: imgVisible
  } = useScrollReveal(0.1);
  return <section className="relative w-full min-h-screen flex items-center overflow-hidden" style={{
    background: 'linear-gradient(160deg, #0D1B2A 0%, #0f1e2e 50%, #0D1B2A 100%)'
  }} data-id="element-110">
      {/* Warm ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[600px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(ellipse, rgba(212,168,83,0.06) 0%, transparent 70%)'
    }} data-id="element-111" />

      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 py-20 lg:py-28" data-id="element-112">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-113">
          {/* Text content */}
          <div ref={textRef} className={`reveal ${textVisible ? 'visible' : ''}`} data-id="element-114">
            {/* Eyebrow */}
            <div className="flex items-center gap-3 mb-6" data-id="element-115">
              <div className="h-px w-8 bg-amber-DEFAULT" style={{
              backgroundColor: '#D4A853'
            }} data-id="element-116" />
              <span className="text-sm font-body font-medium tracking-widest uppercase" style={{
              color: '#D4A853',
              fontFamily: 'DM Sans, sans-serif'
            }} data-id="element-117">
                Protocole d'urgence
              </span>
            </div>

            {/* H1 */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4" style={{
            fontFamily: 'Playfair Display, serif',
            color: '#F5F0E8'
          }} data-id="element-118">
              10 minutes pour{' '}
              <em className="not-italic" style={{
              color: '#D4A853'
            }} data-id="element-119">
                éteindre le cerveau
              </em>
            </h1>

            {/* H2 */}
            <h2 className="text-xl md:text-2xl font-normal mb-6 leading-relaxed" style={{
            fontFamily: 'Playfair Display, serif',
            color: '#C8C0B0',
            fontStyle: 'italic'
          }} data-id="element-120">
              Le protocole d'urgence pour stopper les ruminations nocturnes.
            </h2>

            {/* Subhead */}
            <p className="text-base md:text-lg leading-relaxed mb-10" style={{
            fontFamily: 'DM Sans, sans-serif',
            color: '#C8C0B0'
          }} data-id="element-121">
              Reprenez le contrôle de vos nuits et coupez le pic de cortisol du
              soir{' '}
              <strong style={{
              color: '#F5F0E8'
            }} data-id="element-122">
                sans méditer pendant des heures.
              </strong>
            </p>

            {/* CTA Button */}
            <div className="flex flex-col items-start gap-3" data-id="element-123">
              <button onClick={() => {
              document.getElementById('offer-section')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} className="cta-pulse inline-flex items-center gap-2 px-8 py-5 rounded-xl text-base md:text-lg font-semibold transition-transform hover:scale-105 active:scale-95" style={{
              background: 'linear-gradient(135deg, #D4A853 0%, #E8C47A 50%, #D4A853 100%)',
              color: '#0D1B2A',
              fontFamily: 'DM Sans, sans-serif',
              fontWeight: 600
            }} data-id="element-124">
                OUI, JE VEUX ÉTEINDRE MON CERVEAU ET DORMIR
              </button>
              <p className="text-sm" style={{
              fontFamily: 'DM Sans, sans-serif',
              color: '#8A8070'
            }} data-id="element-125">
                🔒 Paiement sécurisé · Accès immédiat par email
              </p>
            </div>
          </div>

          {/* Product image */}
          <div ref={imgRef} className={`reveal reveal-delay-2 ${imgVisible ? 'visible' : ''} flex justify-center lg:justify-end`} data-id="element-126">
            <div className="relative" data-id="element-127">
              {/* Warm glow behind image */}
              <div className="absolute inset-0 rounded-2xl -m-4" style={{
              background: 'radial-gradient(ellipse, rgba(212,168,83,0.15) 0%, transparent 70%)',
              filter: 'blur(20px)'
            }} data-id="element-128" />
              <img src="https://cdn.magicpatterns.com/uploads/brLSPAMu2RG96icmiyABP5/10_min_pour_eteindre_le_cerveau_VF.png" alt="Guide PDF '10 minutes pour éteindre le cerveau' — tableau de bord sur une table de nuit avec carnet et verre d'eau" className="relative z-10 w-full max-w-md lg:max-w-full rounded-2xl" style={{
              boxShadow: '0 20px 60px rgba(0,0,0,0.6), 0 0 40px rgba(212,168,83,0.15)'
            }} data-id="element-129" />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 pointer-events-none" style={{
      background: 'linear-gradient(to bottom, transparent, #0D1B2A)'
    }} data-id="element-130" />
    </section>;
}